import { Button, type ButtonVariant } from '@zorro/design-system/v2/Button';
import { Flex } from '@zorro/web/design-system';

type Props = {
  onClose: () => void;
  onSubmit: () => void;
  submitVariant?: ButtonVariant;
  submitText: string;
  secondaryText?: string;
  isLoading?: boolean;
  gap?: string;
  pt?: string;
};

export const ModalFooter = ({
  onClose,
  onSubmit,
  submitVariant,
  submitText,
  isLoading,
  secondaryText = 'Cancel',
  gap = 'sm',
  pt = '',
}: Props) => {
  return (
    <Flex justify="flex-end" gap={gap} pt={pt}>
      <Button onClick={onClose} variant="tertiary" size="md">
        {secondaryText}
      </Button>
      <Button
        onClick={onSubmit}
        size="md"
        variant={submitVariant}
        loading={isLoading}
      >
        {submitText}
      </Button>
    </Flex>
  );
};
